var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-load-data',{attrs:{"activeOnLoad":""},on:{"init":_vm.handleLoad_init}},[_c('Export',{attrs:{"userData":_vm.userData},on:{"init":_vm.handleTemplate_init}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }